import React from 'react';
import noNotificationImg from '../../assets/img/nonotification.png';

function NoNotification() {
    return (
        <>
            <div className="card-header text-center">
                <p className="mb-0">You have <span className="font-weight-bold">0</span> notification.</p>
            </div>
            <div className="card-body text-center">
                <p className="text-muted">No notification right now</p>
                <img src={noNotificationImg} alt="No notifications" style={{height: '250px'}}  />
                
                <hr className='mb--5'/>
            </div>
        </>
    );
}

export default NoNotification;
